// Lightweight dev-only logger. In production these become no-ops so
// secrets / PII can't accidentally leak to the browser console.
const isDev = process.env.NODE_ENV === 'development';

export const log = (...args) => { if (isDev) console.log(...args); };
export const warn = (...args) => { if (isDev) console.warn(...args); };
export const error = (...args) => { if (isDev) console.error(...args); };
